"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Email from foundation/Email
 * @trackcomponent
 */
export const Envelope = createSVGIcon(
  <>
    <rect
      stroke="currentColor"
      x="0.5"
      y="0.5"
      width="13.4"
      height="11"
      rx="0.5"
    />
    <path
      stroke="currentColor"
      d="M0.899902 11.7L5.3099 6.29999M13.4999 11.7L9.0899 6.29999"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M0.899902 0.900024L6.44733 7.23994C6.84574 7.69526 7.55407 7.69526 7.95248 7.23994L13.4999 0.900024"
    />
  </>,
  "Envelope",
  { viewBox: "0 0 15 13", titleAccess: "Envelope", fill: "none" }
);
